import { defineComponent as _defineComponent } from 'vue'
import { object, string } from 'yup';
import { useTemplateRef } from 'vue';
import { UiRadioGroup } from '@huntflow/ui';
import RegistrationField from '@/modules/registration/components/RegistrationField.vue';
import BaseButton from '@/shared/legacy/ui/button/button.vue';
import { XSRFHelper } from '@/shared/legacy/lib/util/xsrf-helper';
import FieldsLayout from '@/shared/legacy/ui/fields-layout/fields-layout.vue';
import FormLayout from '@/shared/legacy/ui/form-layout/form-layout.vue';
import {
  ValidationField,
  ValidationProvider,
  yupResolver,
  ValidationErrors
} from '@/shared/legacy/ui/validate-form';
import { useI18N } from '@/shared/legacy/lib/use-i18n';
import BaseSelectDropdown from '@/shared/ui/base-list/base-select-dropdown.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalForm',
  props: {
    fields: {},
    serverErrors: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const i18n = useI18N();

const typeOptions = [
  {
    value: 'internal',
    label: i18n('internal')
  },
  {
    value: 'agency',
    label: i18n('agency')
  }
];

const recruitersSelectOptions = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10 и более'].map((e) => ({
  id: e,
  name: e
}));
const softwareSelectOptions = [
  'Ничего не используем',
  'Excel',
  'E-Staff',
  'Experium',
  'Friendwork',
  'Potok',
  'Talantix',
  'СберПодбор',
  'HRM система (BambooHR, Hurma и др)',
  'CRM (Bitrix24, AmoCRM и др)',
  'Иностранное решение (BreezyHR, Greenhouse и др)',
  'Корп. система (SAP, Axapta, Lotus и др)',
  'Собственная разработка',
  'Другая программа'
].map((e) => ({
  id: e,
  name: e
}));
const defaultValues = {
  first_name: '',
  last_name: '',
  phone: '',
  email: '',
  company: '',
  position: '',
  recruiters_amount: '',
  software: '',
  type: 'internal',
  referer: document.referrer,
  _xsrf: XSRFHelper.getToken(),
  ...__props.fields
};

const resolver = yupResolver(
  object({
    first_name: string().required(),
    last_name: string().required(),
    phone: string().required(),
    email: string().required().email(),
    company: string().required(),
    position: string().required(),
    recruiters_amount: string().required(),
    software: string().required(),
    type: string().required()
  })
);
const privacyPolicyLink = `<a href="/docs/privacy-policy" target="_blank">${i18n('consent.link')}</a>`;

const form = useTemplateRef<HTMLFormElement>('form');

const onSubmit = () => {
  if (form.value) {
    form.value.$el.submit();
  }
};

const __returned__ = { i18n, typeOptions, recruitersSelectOptions, softwareSelectOptions, defaultValues, resolver, privacyPolicyLink, form, onSubmit, get object() { return object }, get string() { return string }, useTemplateRef, get UiRadioGroup() { return UiRadioGroup }, RegistrationField, BaseButton, get XSRFHelper() { return XSRFHelper }, FieldsLayout, FormLayout, get ValidationField() { return ValidationField }, get ValidationProvider() { return ValidationProvider }, get yupResolver() { return yupResolver }, get ValidationErrors() { return ValidationErrors }, get useI18N() { return useI18N }, BaseSelectDropdown }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})